import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceAdminFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { CModal } from '@coreui/react';
import { Loader } from '../components/ModalsCommonFunctions';

const UploadedApps = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosAdminFileUpload = generateAxiosInstanceAdminFileUpload()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const accessToken = localStorage.getItem('accessToken');

    const initialFormState = {
        userType: '',
        userUniqueId: ''
    }

    const initialEditFormState = {
        appName: '',
        publisherName: '',
        apkPath: '',
        apkIconPath: '',
        isInstitute: false,
        userType: '',
        userUniqueId: '',
        userId: "",
        password: ''
    }

    const userTypeMap = {
        'I': 'Institute',
        'B': 'Section',
        'T': 'Teacher',
        'S': 'Student'
    };

    const [filterAppData, setFilterAppData] = useState(initialFormState);
    const [editForm, setEditForm] = useState(initialEditFormState);
    const [appList, setAppList] = useState([]);
    const [isVerified, setIsVerified] = useState(false);
    const inputApkFile = useRef(null);
    const inputApkIconFile = useRef(null);
    const [visible, setVisible] = useState(false);
    const [editId, setEditId] = useState(null);
    const [showPassword, setShowPassword] = useState([]);
    const [showEditPassword, setShowEditPassword] = useState(false);
    const [isChange, setIsChange] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const togglePasswordVisibility = (index) => {
        setShowPassword(prevState => {
            const updatedShowPassword = [...prevState];
            updatedShowPassword[index] = !updatedShowPassword[index];
            return updatedShowPassword;
        });
    };


    useEffect(() => {
        let apiUrl = '/get-apks?';
        if (filterAppData.userType !== '') {
            apiUrl += `userType=${filterAppData.userType}&`;
        }
        if (filterAppData.userUniqueId !== '') {
            apiUrl += `userUniqueId=${filterAppData.userUniqueId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setAppList(response.data.result);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, [filterAppData, refresh]);

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'userUniqueId') {
            setIsVerified(false);
        }
        setEditForm((prevData) => ({
            ...prevData,
            [name]: value
        }));
        setIsChange(true);
    }

    const handleCheckboxChange = () => {
        setEditForm((prevData) => {
            return {
                ...prevData,
                isInstitute: !prevData.isInstitute
            }
        });
        setIsChange(true);
    };

    const handleInputChange = (e) => {
        setFilterAppData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleUploadApkFile = async (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) {
            setEditForm((prevData) => {
                return {
                    ...prevData,
                    apkPath: ''
                }
            })
            return; // Exit function if no file is selected
        }

        const fileExtension = file.name.split(".").pop().toLowerCase();
        const allowedExtensions = ["apk"];
        const body = new FormData();
        body.append("file", file);

        if (allowedExtensions.includes(fileExtension)) {
            setLoading(true);
            const apiUrl = "upload-apk-file";
            authorizedAxiosAdminFileUpload && authorizedAxiosAdminFileUpload.post(apiUrl, body)
                .then((res) => {
                    setEditForm((prevData) => {
                        return {
                            ...prevData,
                            [e.target.name]: res.data.result
                        };
                    });
                    Swal.fire({
                        text: res.data.message
                    })
                })
                .catch((err) => {
                    Swal.fire({ text: "An error occurred while uploading the file" });
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            e.target.value = '';
            Swal.fire({ text: "Only APK files are supported" });
        }
    };

    const handleUploadApkIcon = async (e) => {
        const file = e.target.files[0];
        if (!file) {
            setEditForm((prevData) => {
                return {
                    ...prevData,
                    apkIconPath: ''
                }
            })
            return;
        }

        const fileExtension = file.name.split(".").pop().toLowerCase();
        const allowedExtensions = ["jpeg", "jpg", "png", "webp", "svg", "JPEG", "JPG", "PNG", "WEBP", "SVG"];
        const body = new FormData();
        body.append("file", file);

        if (allowedExtensions.includes(fileExtension)) {
            setLoading(true);
            const apiUrl = "upload-apk-file-icon";
            authorizedAxiosAdminFileUpload && authorizedAxiosAdminFileUpload.post(apiUrl, body)
                .then((res) => {
                    setEditForm((prevData) => {
                        return {
                            ...prevData,
                            [e.target.name]: res.data.result
                        };
                    });
                    Swal.fire({
                        text: res.data.message
                    })
                })
                .catch((err) => {
                    Swal.fire({ text: "An error occurred while uploading the file" });
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            e.target.value = '';
            Swal.fire({ text: "Only JPEG, PNG, WEBP, and SVG files are supported" });
        }
    };

    const [error, setError] = useState()

    useEffect(() => {
        if (editId && editId.length > 0) {
            if (!editForm.userUniqueId && editForm?.userUniqueId?.trim() === "") {
                setError("This field is required.");
            } else {
                setError("");
            }
        }
    }, [editForm.userUniqueId]);

    const updateAppData = (id) => {
        if (editForm.isInstitute == false) {
            setLoading(true);
            const apiUrl = `/edit-apk?id=${id}`;
            const data = {
                ...editForm,
            }
            delete data.userType;
            delete data.userUniqueId;
            delete data.userId;
            delete data.password;

            authorizedAxios && authorizedAxios.put(apiUrl, data)
                .then(response => {
                    setEditId(null);
                    setEditForm(initialEditFormState);
                    inputApkFile.current.value = '';
                    inputApkIconFile.current.value = '';
                    setIsVerified(false);
                    setVisible(!visible);
                    setRefresh(!refresh);
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else if (editForm.isInstitute == true && editForm.userUniqueId != "" && editForm.userUniqueId.length > 0) {
            setLoading(true);
            const apiUrl = `/edit-apk?id=${id}`;
            authorizedAxios && authorizedAxios.put(apiUrl, editForm)
                .then(response => {
                    setEditId(null);
                    setEditForm(initialEditFormState);
                    inputApkFile.current.value = '';
                    inputApkIconFile.current.value = '';
                    setIsVerified(false);
                    setVisible(!visible);
                    setRefresh(!refresh);
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else if (editForm.isInstitute == true && editForm.userUniqueId == "" && editForm.userUniqueId.length == 0) {
            setError("This field is required.");
        }
    }

    const handleVerifyUser = (e) => {
        if (editForm.isInstitute == true && editForm.userUniqueId !== "" && editForm.userUniqueId.length > 0) {
            setLoading(true);
            const apiUrl = `/verify-user?userUniqueId=${editForm.userUniqueId}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setEditForm((prevData) => {
                        return {
                            ...prevData,
                            userId: response.data.result.id
                        }
                    })

                    setIsVerified(true);
                    Swal.fire({
                        text: response.data.message
                    })
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        text: errorMsg
                    })
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else if (editForm.isInstitute == true && editForm.userUniqueId !== "" && editForm.userUniqueId.length > 0) {
            setError("This field is required.");
        }
    }

    const deleteAppData = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-apks?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    setAppList((prevList) => [...prevList].filter((item) => item.id !== id))
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const handleUpdateDisabled = () => {
        if (editForm.isInstitute && !isVerified && isChange) {
            return true;
        } else if (!editForm.isInstitute && !isChange) {
            return true;
        } else if (editForm.isInstitute && !isVerified && !isChange) {
            return true;
        }

        return false;
    }

    const changeActive = (id) => {
        setLoading(true);
        const apiUrl = `/active-or-deactive-apk?id=${id}`;
        authorizedAxios && authorizedAxios.patch(apiUrl)
            .then(response => {
                setRefresh(!refresh);
                setTimeout(() => {
                    Swal.fire({ text: response.data.message });
                }, 100);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Uploaded Apps</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-box"></i> Uploaded Apps</b></h4>
                                </div>
                                <div className="card-body ">

                                    <CModal
                                        backdrop="static"
                                        visible={visible}
                                        onClose={() => setVisible(false)}
                                        aria-labelledby="LiveDemoExampleLabel"
                                        onIni className='assign-modal'
                                    >
                                        <div className="row">
                                            <div className='popoup-title text-center w-100'><h3>Edit App Data</h3></div>
                                            <button type="button" className="btn-close" aria-label="Close" onClick={() => { setVisible(false); setIsVerified(false); setEditForm(initialFormState); setIsChange(false) }}></button>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <label for="appName" className="col-form-label">Name of App :</label>
                                                <input type="text" className="form-control" name="appName" value={editForm.appName} onChange={handleEditInputChange} />
                                                {/* {error.appName && <p style={{ color: 'red' }}>{error.appName}</p>} */}
                                            </div>

                                            <div className="col-md-6">
                                                <label for="publisherName " className="col-form-label">Publisher :</label>
                                                <input type="text" className="form-control" name="publisherName" value={editForm.publisherName} onChange={handleEditInputChange} />
                                                {/* {error.publisherName && <p style={{ color: 'red' }}>{error.publisherName}</p>} */}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <label for="apkPath" className="col-form-label">APK Path : </label>
                                                <input required type="file" className="form-control" name="apkPath" onChange={handleUploadApkFile} ref={inputApkFile} />
                                                {/* {error.apkPath && <p style={{ color: 'red' }}>{error.apkPath}</p>} */}

                                            </div>

                                            <div className="col-md-6">
                                                <label for="apkIconPath" className="col-form-label">Upload Icon :</label>
                                                <input required type="file" className="form-control" name="apkIconPath" onChange={handleUploadApkIcon} ref={inputApkIconFile} />
                                                {/* {error.apkIconPath && <p style={{ color: 'red' }}>{error.apkIconPath}</p>} */}
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label for="isInstitute" className="col-form-label">Is Institute App :</label>
                                                <input type="checkbox" name="isInstitute" /*defaultValue={false}*/ checked={editForm?.isInstitute} style={{
                                                    marginLeft: '20px', width: '18px',
                                                    height: '16px',
                                                    accentColor: 'green', marginTop: '20px',
                                                }} onChange={handleCheckboxChange} />
                                            </div>
                                        </div>

                                        {editForm.isInstitute && <div className='row'>
                                            <div className="col-md-6">
                                                <label for="userType" className="col-form-label">For :</label>
                                                <select required class="form-select" aria-label="Default select example" name='userType' onChange={handleEditInputChange} value={editForm.userType}>
                                                    <option selected value={''} >--Select--</option>
                                                    {/* <option value='I'>Institute</option> */}
                                                    {/* <option value='B'>Section</option> */}
                                                    <option value='T'>Teacher</option>
                                                    <option value='S'>Student</option>
                                                </select>
                                                {/* {error.userType && <p style={{ color: 'red' }}>{error.userType}</p>} */}
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="password" className="col-form-label">App Password :</label>
                                                <div className="input-group password_field">
                                                    <input type={showEditPassword ? "text" : "password"} className="form-control" name="password" value={editForm.password} onChange={handleEditInputChange} />
                                                    {showEditPassword ? (
                                                        <button><i className="fa fa-eye" aria-hidden="true" onClick={() => setShowEditPassword(!showEditPassword)}></i></button>
                                                    ) : (
                                                        <button><i className="fa fa-eye-slash" onClick={() => setShowEditPassword(!showEditPassword)}></i></button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>}

                                        {editForm.isInstitute && <div className='row'>
                                            <div className='col-md-6'>
                                                <label for="userUniqueId" className="col-form-label"><span style={{ color: "red" }}>*</span>Institute Id :</label>

                                                <div className='vefify_field'>
                                                    <input type="text" className="form-control" name="userUniqueId" value={editForm.userUniqueId} onChange={handleEditInputChange} />

                                                    {isVerified === false && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={handleVerifyUser}>Verify</button>}
                                                    {isVerified === true && <button className="btn btn-success" type="button" style={{ marginRight: '20px' }}><i class="fa-solid fa-check"></i></button>}
                                                </div>
                                                {error && <p style={{ color: 'red' }}>{error}</p>}

                                            </div>
                                        </div>}

                                        <div className="row">
                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <div className="col-auto">
                                                    <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} disabled={handleUpdateDisabled()} onClick={() => updateAppData(editId)}>Update</button>
                                                    <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={() => { setEditForm(initialFormState); inputApkFile.current.value = ''; inputApkIconFile.current.value = '' }}>Reset</button>
                                                </div>
                                            </div>
                                        </div>
                                    </CModal>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label for="userType" className="col-form-label">Filter For :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='userType' onChange={handleInputChange} value={filterAppData.userType}>
                                                        <option selected value={''} >--Select--</option>
                                                        {/* <option value='I'>Institute</option>
                                                    <option value='B'>Section</option> */}
                                                        <option value='T'>Teacher</option>
                                                        <option value='S'>Student</option>
                                                    </select>
                                                    {/* {error.userType && <p style={{ color: 'red' }}>{error.userType}</p>} */}
                                                </div>

                                                <div className='col-md-6'>
                                                    <label for="userUniqueId" className="col-form-label">Search Using Institute Id :</label>
                                                    <input type="text" className="form-control" name="userUniqueId" value={filterAppData.userUniqueId} onChange={handleInputChange} />
                                                    {/* {error.userUniqueId && <p style={{ color: 'red' }}>{error.userUniqueId}</p>} */}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={() => { setFilterAppData(initialFormState) }}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">App Name </th>
                                                                        <th scope="col">Publisher</th>
                                                                        <th scope="col">Apk</th>
                                                                        <th scope='col'>User Type</th>
                                                                        <th scope='col'>Institute Id</th>
                                                                        <th scope='col'>Password</th>
                                                                        <th scope='col'>Action</th>
                                                                        <th scope='col'>Active/Inactive</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        appList?.length > 0 ?
                                                                            appList?.map((item, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        {/* <th>{item.isApproved || <input type='checkbox' checked={aprovedStudentData.includes(item.id)} onClick={() => { aprovedStudentData.includes(item.id) ? setAproveStudentData(aprovedStudentData.filter(i => i !== item.id)) : setAproveStudentData(pre => [...pre, item.id]) }} />}</th> */}
                                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                        <td>{item.appName}</td>
                                                                                        <td>{item.publisherName}</td>
                                                                                        <td>
                                                                                            <a href={item.apkPath} download>
                                                                                                <img className='download-app' src={item.apkIconPath} alt="APK Icon" style={{ width: '50px', height: '50px' }} title='click to download Apk' />
                                                                                            </a>
                                                                                        </td>
                                                                                        <td>{userTypeMap[item.userType]}</td>
                                                                                        <td>{item.userUniqueId}</td>
                                                                                        <td>
                                                                                            {item.isInstitute && (showPassword[index] ? (item.password) : ('••••••••'))}
                                                                                            {item.isInstitute && <button
                                                                                                className="btn btn-link"
                                                                                                type="button"
                                                                                                onClick={() => togglePasswordVisibility(index)}
                                                                                            >
                                                                                                <i className={`fa ${showPassword[index] ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                                                                            </button>}
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setEditForm({
                                                                                                    appName: item?.appName,
                                                                                                    publisherName: item?.publisherName,
                                                                                                    apkPath: item?.apkPath,
                                                                                                    apkIconPath: item?.apkIconPath,
                                                                                                    userType: item?.userType,
                                                                                                    userUniqueId: item?.userUniqueId,
                                                                                                    password: item?.password,
                                                                                                    isInstitute: item?.isInstitute
                                                                                                });
                                                                                                setEditId(item.id);
                                                                                                // document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                                setVisible(!visible);
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" /*disabled={editId === lesson.id}*/ type="button" onClick={() => deleteAppData(item.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                        <td className='toggle_switch_id'>
                                                                                            <div className={`toggle-container margin-inline ${item.isActive ? 'active' : ''}`} onClick={() => changeActive(item.id)}>
                                                                                                <div className="toggle-background"></div>
                                                                                                <div className="toggle-switch"></div>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Apps Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default UploadedApps;